export function parseMarkdownToHtml(text) {
  if (!text) return "";

  // 1. Escapar HTML para segurança (XSS prevention)
  let html = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  // 2. Protect URLs before WhatsApp formatting. Underscores in signed links
  // (aws4_request, filenames) and later target="_blank" would otherwise be
  // eaten by the italic rule /_(.+?)_/.
  const urls = [];
  html = html.replace(/(https?:\/\/[^\s<]+)/g, (match) => {
    const index = urls.length;
    urls.push(match);
    return `<<URL${index}>>`;
  });

  // 3. Formatação estilo WhatsApp
  html = html.replace(/\*(.+?)\*/g, "<strong>$1</strong>"); // Negrito
  html = html.replace(/_(.+?)_/g, "<em>$1</em>");         // Itálico
  html = html.replace(/~(.+?)~/g, "<del>$1</del>");       // Riscado
  html = html.replace(/`(.+?)`/g, "<code>$1</code>");     // Code

  // 4. Restore URLs as links
  urls.forEach((url, index) => {
    html = html.replace(
      `<<URL${index}>>`,
      `<a href="${url}" target="_blank" class="kv-content-url">${url}</a>`
    );
  });

  // 5. Quebras de linha
  html = html.replace(/\n/g, "<br>");

  return html;
}
